(function () {
  'use strict';
  var root = document.querySelector('[data-neon]');
  if (!root) return;
  var A = window.AcrylicStyles || {};
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var stage = $('[data-stage]'), sign = $('[data-sign]'), txt = $('[data-txt]');
  var ov = $('[data-ov]'), holder = stage.parentNode, mark = document.createComment('ns');
  var ta = $('[data-text]'), sel = $('[data-letters]');

  var iconPrice = Number(root.dataset.iconPrice || 500);
  var remotePrice = Number(root.dataset.remotePrice || 999);
  var tiers = (root.dataset.tiers || '').split(/\n+/).map(function (l) {
    var p = l.split('|').map(function (x) { return Number(String(x).trim()); });
    return p.length === 4 && p.every(function (n) { return n > 0; }) ? { max: p[0], w: p[1], h: p[2], price: p[3] } : null;
  }).filter(Boolean).sort(function (a, b) { return a.max - b.max; });
  if (!tiers.length) tiers = [{ max: 20, w: 18, h: 12, price: 1999 }];
  var variants = [];
  try { variants = JSON.parse($('[data-variants]').textContent || '[]'); } catch (e) {}

  var st = { letters: 0, text: '', font: $('.ns-font').dataset.font, fontName: $('.ns-font').textContent,
    color: '#ffe81a', colorName: 'Yellow', zoom: 1, icons: [], hang: '', remote: false, qty: 1 };
  var ICO_LABEL = {};
  $$('[data-icon]').forEach(function (b) { ICO_LABEL[b.dataset.icon] = b.dataset.label; });

  function money(n) { return 'Rs.' + Number(n).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function toast(m) { (A.toast || function (x) { alert(x); })(m); }
  function tier() {
    for (var i = 0; i < tiers.length; i++) if (st.letters <= tiers[i].max) return tiers[i];
    return tiers[tiers.length - 1];
  }
  function ft(i) { var f = Math.round(i / 12 * 100) / 100; return f; }
  function ftLabel(i) { var f = ft(i); return f + ' ' + (f < 2 ? 'foot' : 'feet') + ' / ' + i + ' inches'; }
  function total() { return tier().price + st.icons.length * iconPrice + (st.remote ? remotePrice : 0); }
  function sizeText() { var t = tier(); return ft(t.w) + 'ft x ' + ft(t.h) + 'ft'; }

  function fit() {
    var W = stage.clientWidth, H = stage.clientHeight;
    if (!W || !H) return;
    sign.style.fontSize = '100px';
    var w = sign.offsetWidth, h = sign.offsetHeight;
    if (!w || !h) return;
    var k = Math.min(W * 0.6 / w, H * 0.42 / h);
    sign.style.fontSize = Math.max(10, 100 * k * st.zoom) + 'px';
  }

  function render() {
    root.style.setProperty('--nc', st.color);
    sign.style.setProperty('--nc', st.color);
    var t = tier();
    txt.textContent = st.text || 'Type here';
    txt.classList.toggle('ph', !st.text);
    txt.style.fontFamily = "'" + st.font + "',cursive";
    sign.querySelectorAll('.ns-ico,.ns-dot').forEach(function (n) { n.remove(); });
    st.icons.forEach(function (k) {
      sign.insertAdjacentHTML('beforeend', '<svg class="ns-ico" viewBox="0 0 48 48" aria-hidden="true"><use href="#nsi-' + k + '"/></svg>');
    });
    sign.dataset.hanging = st.hang;
    if (st.hang === 'stand') sign.insertAdjacentHTML('beforeend', '<i class="ns-dot"></i><i class="ns-dot"></i><i class="ns-dot"></i><i class="ns-dot"></i>');
    $('[data-dim-w]').textContent = ftLabel(t.w);
    $('[data-dim-h]').textContent = ftLabel(t.h);
    $('[data-size]').textContent = 'Size will be ' + sizeText();
    $('[data-max]').textContent = st.letters ? 'Max character ' + st.letters + ' including spaces' : 'Select number of letters first';
    $('[data-price]').textContent = money(total());
    var sub = $('[data-sub]');
    sub.textContent = st.qty > 1 ? st.qty + ' × ' + money(total()) + ' = ' + money(total() * st.qty) : '';
    ta.disabled = !st.letters;
    ta.maxLength = st.letters || 200;
    ta.placeholder = st.letters ? 'Type your text here…' : '1st step: choose number of letters';
    $('[data-qty]').value = st.qty;
    $$('.ns-font').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.font === st.font)); });
    $$('.ns-color').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.color === st.color)); });
    $$('[data-icon]').forEach(function (b) { b.setAttribute('aria-pressed', String(st.icons.indexOf(b.dataset.icon) > -1)); });
    $$('[data-hang]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.hang === st.hang)); });
    $$('[data-remote]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.dataset.remote === '1') === st.remote)); });
    fit();
  }

  function clean(v) {
    var lines = v.replace(/\r/g, '').split('\n').slice(0, 3), out = [], used = 0;
    lines.forEach(function (l) {
      var room = st.letters - used; if (room < 0) room = 0;
      l = l.slice(0, room); used += l.length; out.push(l);
    });
    return out.join('\n');
  }

  sel.addEventListener('change', function () {
    st.letters = Number(sel.value) || 0;
    st.text = clean(st.text);
    ta.value = st.text;
    render();
    if (st.letters) ta.focus();
  });
  ta.addEventListener('input', function () { st.text = clean(ta.value); if (ta.value !== st.text) ta.value = st.text; render(); });
  $('[data-text-wrap]').addEventListener('click', function () { if (!st.letters) { toast('1st step: please select number of letters first'); sel.focus(); } });

  root.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('.ns-font'))) {
      st.font = b.dataset.font; st.fontName = b.textContent.trim();
      if (document.fonts && document.fonts.load) document.fonts.load('48px "' + st.font + '"').then(fit);
      return render();
    }
    if ((b = e.target.closest('.ns-color'))) { st.color = b.dataset.color; st.colorName = b.dataset.name; return render(); }
    if ((b = e.target.closest('[data-icon]'))) {
      var k = b.dataset.icon, i = st.icons.indexOf(k);
      if (i > -1) st.icons.splice(i, 1); else st.icons.push(k);
      return render();
    }
    if (e.target.closest('[data-icon-clear]')) { st.icons = []; return render(); }
    if ((b = e.target.closest('[data-hang]'))) { st.hang = b.dataset.hang; return render(); }
    if (e.target.closest('[data-hang-clear]')) { st.hang = ''; return render(); }
    if ((b = e.target.closest('[data-remote]'))) { st.remote = b.dataset.remote === '1'; return render(); }
    if (e.target.closest('[data-remote-clear]')) { st.remote = false; return render(); }
    if ((b = e.target.closest('[data-zoom]'))) {
      st.zoom = Math.min(1.4, Math.max(0.5, Math.round((st.zoom + Number(b.dataset.zoom) * 0.1) * 10) / 10));
      return render();
    }
    if ((b = e.target.closest('[data-q]'))) { st.qty = Math.max(1, st.qty + Number(b.dataset.q)); return render(); }
    if (e.target.closest('[data-preview]')) { if (valid()) openFull(); return; }
    if (e.target.closest('[data-add]')) { if (valid()) add(false); return; }
    if (e.target.closest('[data-buy]')) { if (valid()) add(true); return; }
    if (e.target.closest('[data-wa]')) { if (valid()) whatsapp(); }
  });
  $('[data-qty]').addEventListener('change', function (e) { st.qty = Math.max(1, parseInt(e.target.value, 10) || 1); render(); });

  function valid() {
    if (!st.letters) { toast('Please select number of letters first'); sel.focus(); return false; }
    if (!st.text.replace(/\s/g, '')) { toast('Please write your text first'); ta.focus(); return false; }
    return true;
  }

  /* preview lightbox */
  function openFull() {
    holder.insertBefore(mark, stage);
    document.body.appendChild(stage);
    stage.classList.add('full'); ov.hidden = false; document.body.appendChild(ov);
    document.body.classList.add('ns-lock');
    requestAnimationFrame(fit);
  }
  function closeFull() {
    if (!stage.classList.contains('full')) return;
    stage.classList.remove('full'); ov.hidden = true;
    mark.parentNode.insertBefore(stage, mark); mark.remove();
    holder.appendChild(ov);
    document.body.classList.remove('ns-lock');
    requestAnimationFrame(fit);
  }
  stage.querySelector('[data-close]').addEventListener('click', closeFull);
  ov.addEventListener('click', closeFull);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFull(); });

  /* order */
  function props() {
    var p = {
      'Text': st.text, 'Number of letters': String(st.letters), 'Font': st.fontName, 'Colour': st.colorName,
      'Size': sizeText()
    };
    if (st.icons.length) p['Signs'] = st.icons.map(function (k) { return ICO_LABEL[k]; }).join(', ');
    if (st.hang) p['Hanging'] = $('[data-hang="' + st.hang + '"]').dataset.label;
    p['Remote'] = st.remote ? 'Yes' : 'No';
    p['Price (estimated)'] = money(total());
    return p;
  }
  function pick() {
    var want = Math.round(total() * 100), av = variants.filter(function (v) { return v.available; });
    var hit = av.filter(function (v) { return v.price === want; })[0];
    return { v: hit || av[0], exact: !!hit };
  }
  function add(now) {
    var c = pick();
    if (!c.v) { toast('Cart is not set up yet - please use Order on WhatsApp'); return; }
    if (!c.exact) toast('Final price will be confirmed on WhatsApp');
    var item = { id: c.v.id, quantity: st.qty, properties: props() };
    if (!now && A.addMany) return A.addMany([item]);
    var url = ((A.routes || {}).cartAdd || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw 0; window.location.href = (A.routes || {}).checkout || '/checkout'; })
      .catch(function () { toast('Could not add to cart'); });
  }
  function whatsapp() {
    var p = props(), lines = Object.keys(p).map(function (k) { return k + ': ' + p[k]; });
    var msg = 'Hi Acrylic Styles, I want to order a custom neon sign:\n' + lines.join('\n') + '\nQuantity: ' + st.qty + '\nTotal: ' + money(total() * st.qty);
    window.open('https://wa.me/' + (root.dataset.whatsapp || A.whatsapp || '923127739750') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
  }

  if (window.ResizeObserver) new ResizeObserver(fit).observe(stage); else window.addEventListener('resize', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  render();
})();
